/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import Group from "../../models/Group";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import { Dropdown } from "primereact/dropdown";
import Category from "../../models/Category";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";

interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    groupCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    groupDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    groupCategoryCd: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    groupStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    groupUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    groupUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function GroupView() {
    let empty: Group = {
        groupCd: '',
        groupDesc: '',
        groupStatus: '',
        groupCategoryCd: '',
        groupUpdTs: '',
        groupUpdUser: ''
    };

    const status: DropdownItem[] = useMemo(
        () => [
            { name: 'Active', code: 'A' },
            { name: 'Deleted', code: 'D' }
        ],
        []
    );

    const [listValues, setListValues] = useState<Group[]>([]);
    const [listFilteredData, setListFilteredData] = useState<Group[]>([]);
    const [listCategories, setListCategories] = useState<Category[]>([]);
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [singleValue, setSingleValue] = useState<Group>(empty);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const dt = useRef<any>(null);

    useEffect(() => {
        MaintenanceService.getCategories().then(data => {
            setListCategories(data);
        });

        MaintenanceService.getGroups().then(data => {
            setListValues(data);
            setLoading(false);
        });

        initFilters();
    }, []);

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    useEffect(() => {
        MaintenanceService.getGroups().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: Group) => [
            item.groupCd,
            item.groupDesc,
            item.groupCategoryCd,
            item.groupStatus,
            item.groupUpdTs,
            item.groupUpdUser
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Code', 'Description', 'Category Code', 'Status', 'Last Update Date', 'Last Update User']], body: bodyData })
                doc.save('groups.pdf');
            });
        });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const groupCdTemplate = (rowData: Group) => {
        return rowData.groupCd;
    }

    const groupDescTemplate = (rowData: Group) => {
        return rowData.groupDesc;
    }

    const groupCategoryCdTemplate = (rowData: Group) => {
        return rowData.groupCategoryCd;
    }

    const groupStatusTemplate = (rowData: Group) => {
        return rowData.groupStatus;
    }

    const groupUpdTsTemplate = (rowData: Group) => {
        return rowData.groupUpdTs;
    }

    const groupUpdUserTemplate = (rowData: Group) => {
        return rowData.groupUpdUser;
    }

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };
        _value.groupCd = data.groupCd;
        _value.groupDesc = data.groupDesc;
        _value.groupCategoryCd = data.groupCategoryCd;
        _value.groupStatus = data.groupStatus;

        if (accounts[0]) {
            _value.groupUpdTs = new Date().toISOString();
            _value.groupUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };

    const save = (value: Group) => {
        MaintenanceService.addGroup(value).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Group Created', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Group', life: 3000 });
        });
    }

    const update = (value: Group, oldId: string) => {
        MaintenanceService.updateGroup(value, oldId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Group Updated', life: 3000 });
            setSingleValue(empty);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Group', life: 3000 });
        });
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<Group[]>) => {
        let selectedIndex = listValues.findIndex(v => v.groupCd === (rowData.value as Group).groupCd);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].groupCd}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.groupCd === newData.groupCd);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'groupCd':
                return groupCdEditor(options);

            case 'groupDesc':
                return groupDescEditor(options);

            case 'groupCategoryCd':
                return groupCategoryCdEditor(options);

            case 'groupStatus':
                return groupStatusEditor(options);
        }
    }

    const groupCdEditor = (options: any) => {
        return (
            <Controller
                name="groupCdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Code is required.',
                    validate: {
                        unique: v => listValues.filter(val => val.groupCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Group code must be unique.'
                    }
                }}
                render={({ field, fieldState }) => {
                    singleValue.groupCd = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={3} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.groupCd = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Code" />
                        </>
                    )
                }
                }
            />
        );
    }

    const groupDescEditor = (options: any) => {
        return (
            <Controller
                name="groupDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    singleValue.groupDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={25} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.groupDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }
                }
            />
        );
    }

    const groupCategoryCdEditor = (options: any) => {
        return (
            <Controller
                name="groupCategoryCdEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Category Code is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.groupCategoryCd = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={listCategories} optionLabel="categoryCd" optionValue="categoryCd" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.groupCategoryCd = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const groupStatusEditor = (options: any) => {
        return (
            <Controller
                name="groupStatusEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Status is required.'
                }}
                render={({ field, fieldState }) => {
                    singleValue.groupStatus = field.value;
                    return (
                        <>
                            <Dropdown ref={field.ref} inputId={field.name} value={fieldState.isDirty ? field.value : options.value} options={status} optionLabel="name" optionValue="code" tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => { singleValue.groupStatus = e.target.value; field.onChange(e.value) }} placeholder="Select..." />
                        </>
                    )
                }
                }
            />
        );
    }

    const rowEditorTemplate = (rowData: Group, props: any) => {
        const rowEditor = props.rowEditor;
        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("groupCdEdit").invalid && !formEdit.getFieldState("groupDescEdit").invalid) {
                            let _singleValue = { ...singleValue };
                            let oldId = rowData.groupCd;

                            if (accounts[0]) {
                                _singleValue.groupUpdTs = new Date().toISOString();
                                _singleValue.groupUpdUser = accounts[0].username.split('@')[0];
                            }

                            update(_singleValue, oldId);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: Group) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteGroup(singleValue.groupCd).then((data: boolean) => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Group" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-2">
                            <Controller
                                name="groupCd"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Code is required.',
                                    validate: {
                                        unique: v => listValues.filter(val => val.groupCd.toLowerCase() === v.toLowerCase()).length === 0 || 'Group code must be unique.'
                                    }
                                }}
                                render={({ field, fieldState }) => (

                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Group Code</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={3} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { field.onChange(e.target.value.toUpperCase()); }} placeholder="Group Code" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('groupCd')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="groupDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {(field.value !== null && field.value !== undefined) ? <small className="text-primary">{field.value}</small> : <></>}
                                        {getErrorMessage('groupDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="groupCategoryCd"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Category Code is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Category Code</label>
                                        <Dropdown inputId={field.name} value={field.value} options={listCategories} optionLabel="categoryCd" optionValue="categoryCd" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('groupCategoryCd')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field col-2">
                            <Controller
                                name="groupStatus"
                                control={form.control}
                                defaultValue={'A'}
                                rules={{
                                    required: 'Status is required.'
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Status</label>
                                        <Dropdown inputId={field.name} value={field.value} options={status} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                            onChange={(e) => { field.onChange(e.value) }} placeholder="Select..." />
                                        {getErrorMessage('groupStatus')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="groupCd" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No group records found." header={header}>
                <Column field="groupCd" header="Group Code" sortable body={groupCdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="groupDesc" header="Description" sortable body={groupDescTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="groupCategoryCd" header="Category Code" sortable body={groupCategoryCdTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="groupStatus" header="Status" sortable body={groupStatusTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="groupUpdTs" header="Last Update Date" sortable body={groupUpdTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="groupUpdUser" header="Last Update User" sortable body={groupUpdUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.groupCd}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}